import { render } from "./FormularioSaidaAnimal.vue?vue&type=template&id=5d21df89&scoped=true"
import script from "./FormularioSaidaAnimal.vue?vue&type=script&lang=js"
export * from "./FormularioSaidaAnimal.vue?vue&type=script&lang=js"

import "./FormularioSaidaAnimal.vue?vue&type=style&index=0&id=5d21df89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d21df89"]])

export default __exports__